module.exports = __webpack_public_path__ + "img/office.0eaa48a9.png";